import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import * as React from "react";
import { Row } from "react-bootstrap";
import {
  container,
  creditCard,
  promotionTitle,
  primaryButton,
  styledRow,
  promotionLeftContent,
} from "./ParagraphMerchandisingBlock.module.scss";

export const Container: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const PrimaryButton: React.FC<any> = (props) => {
  return <div className={primaryButton}>{props.children}</div>;
};
export const StyledRow: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <Row className={styledRow}> {props.children} </Row>;
};
export const PromotionLeftContent: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <div className={promotionLeftContent}>{props.children}</div>;
};
export const PromotionLeftContainer: React.FC<{
  field_link: { url: string; title: string };
  ctaDescription: string;
}> = (props) => {
  return (
    <div>
      <Link to={props?.field_link?.url} target="_blank">
        <PrimaryButton> {props?.field_link?.title} </PrimaryButton>
      </Link>
      <PromotionLeftContent>
        <p>{props.ctaDescription} </p>
      </PromotionLeftContent>
    </div>
  );
};
export const PromotionTitle: React.FC<{
  field_description_formatted: { processed: string };
}> = (props) => {
  return (
    <div
      className={promotionTitle}
      dangerouslySetInnerHTML={{
        __html: props.field_description_formatted?.processed,
      }}
    ></div>
  );
};
export const CreditCard: React.FC<{
  image: any;
  altText: string;
}> = (props) => {
  return (
    <div className={creditCard}>
      <GatsbyImage image={props.image} alt={props.altText} />
    </div>
  );
};
